export default {
  params: ['occupiedOption'],
  validate: ({ adults, children }, { occupiedOption }) => {
    if (!occupiedOption) {
      return {
        required: true,
        valid: Number(adults) > 0,
      };
    }

    return {
      required: true,
      valid: Number(adults) > 1 ||
        (Number(adults) > 0 && Number(children > 0)),
    };
  },
  message (fieldName, { _value_: { adults }, occupiedOption }) {
    if (!adults) return 'Please select the number of adults/children who occupy the property';
    return `You have selected '${this.constants.HOME_PROPERTY_OCCUPIED[occupiedOption]}': Please review number of adults/children selected or change selection of who occupies the property.`;
  },
  computesRequired: true,
};
